export interface ISignupApiDto {
  full_name: string;
  email: string;
  password: string;
  confirm_password: string;
  phone_number: number;
  id: number;
}

export interface ISignup {
  fullName: string;
  email: string;
  password: string;
  confirmPassword: string;
  phoneNumber: number;
  id: number;
}

export interface IApiResponse {
  data: any;
  status_code: number;
}

export interface IVerifyOtp {
  email: string;
  otp_type: string;
  otp: number;
}

export interface IResendOtp {
  email: string;
  otp_type: string;
}

export interface IResendApiResponse {
  data: IDetailMessage;
  status_code: number;
}

export interface IDetailMessage {
  detail: string;
}
export interface IConfirmOtp {
  token: string;
  message: string;
}

export interface IConfirmOtpResponse {
  data: IConfirmOtp;
  status_code: number;
}
export interface IResetPassword {
  detail: string;
}
export interface IResetPasswordResponse {
  data: IResetPassword;
  status_code: number;
}

export interface IUserProfile {
  full_name: string;
  profile_picture: string;
  address: string;
  phone_number: number;
  latitude: number;
  longitude: number;
  id: number;
  email: string;
}

export interface IUpdatePassword {
  current_password: string;
  password: string;
  confirm_password: string;
}
export class FileExtension {
  constructor(
    public extension: string,
    public description: string,
    public category = '') {
  }
}
